import * as React from "react";
import Modal from "../../ui/modal/Modal";
import {Option} from "ts-option";
import MentionUtils from "../../../utils/MentionUtils";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

const sanitizeHtml = require("sanitize-html");

interface ComponentProps {
	/**
	 * Modal close callback.
	 */
	onCloseClicked: () => void;
	/**
	 * Html content to display.
	 */
	htmlContent: Option<string>
}

export default class InvoiceSentEmailPreviewModal extends React.PureComponent<ComponentProps> {
	render() {
		const html = sanitizeHtml(MentionUtils.getPlainText(this.props.htmlContent.orNull), {
			allowedTags: ["span", "a", "div", "style", "strong", "br", "img", "button"],
			allowedAttributes: {
				"span": ["class", "style"],
				"a": ["class", "style"],
				"div": ["class", "id", "style"],
				"style": ["type"],
				"img": ["src", "width", "height", "style"],
				"button": ["style", "type",]
			}
		});

		return (
			<Modal onCloseClicked={this.props.onCloseClicked}
				   title={"Email preview"}
				   customClass={"invoice-sent-email-preview-modal"}
				   mediumWidth>
				<div>
					<div className={"email-sent-content"}
						 dangerouslySetInnerHTML={{__html: html}}/>
					<div className="close-button-container">
						<ButtonPrimary label={"Close"}
									   onClick={this.props.onCloseClicked}/>
					</div>
				</div>
			</Modal>
		)
	}
}
